import * as React from "react";
import { useHubilPdfListener } from "@/utils/useHubilPdfListener";

/**
 * Composant sans rendu qui écoute les postMessage HUBIL_OPEN_PDF
 * et ouvre le PDF en slide NodeAuto.
 * À monter dans un SlidesProvider existant (ex: /rse ou /part-selector).
 */
export const HubilPdfBridge = (): null => {
    useHubilPdfListener();
    return null;
};
